<template>
  <div class="work">
    <audio src="" id="audio" style="display: none" autoplay></audio>
    <header>
      <div class="tab">
        <div class="tab-1 active">歌曲</div>
      </div>
      <div class="add" @click="gotoAdd">上传歌曲</div>
      <!-- <div class="search-c">
        <input
          class="center-y search"
          v-model="search"
          type="text"
          placeholder="请输入歌曲名称"
        />
        <img
          class="center-y"
          style="right: 10px"
          src="../assets/img/search.png"
          alt=""
          srcset=""
        />
      </div> -->
    </header>
    <div class="content">
      <el-table
        :data="songList"
        style="width: 100%"
        height="calc(100vh - 100px)"
        ref="songsTable"
      >
        <el-table-column
          type="index"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="歌曲名">
          <template slot-scope="scope">
            <span @click="play(scope.row.song_hash, scope.row.id)" style="cursor: pointer">
              <span
                :id="scope.row.id"
                class="play"
                alt=""
                srcset=""
              ></span>
              <span>{{ scope.row.song_name }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="author_name" label="歌手名"></el-table-column>
        <el-table-column prop="composer" label="作曲人"></el-table-column>
        <el-table-column prop="lyrics" label="作词人"></el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at.split(" ")[0] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at.split(" ")[0] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态"  align="center">
          <template slot-scope="scope">
            <span>{{ checkStatus(scope) }}</span>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">{{ scope.row.review_message }}</div>
              <span class="notpass-reason" v-show="scope.row.review_status == 3"
                >!</span
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="上架状态" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">{{ sjStatus(scope) }}</div>
              <span v-if="scope.row.audio">
                <img class="status-img" v-if="scope.row.audio.is_publish == 1" src="../assets/img/publish.png?v=20201104" alt="" srcset="">
                <img class="status-img" v-else src="../assets/img/notpublish.png?v=20201104" alt="" srcset="">
              </span>
              <span v-else>
                <img class="status-img" src="../assets/img/notpublish.png?v=20201104" alt="">
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <span style="color:#0090ff;cursor: pointer;" @click="toggleRowExpansion(scope.row)">详情</span> -->
            <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.is_publish == 1 || scope.row.review_status == 1 || scope.row.review_status == 2">
              <div slot="content">{{toolTip(scope)}}</div>
              <span style="color: #888; cursor: pointer">编辑</span
            >
            </el-tooltip>
            
            <span v-else
              style="color: #0090ff; cursor: pointer"
              @click="editSong(scope.row.id)"
              >编辑</span
            >
          </template>
        </el-table-column>
        <el-table-column type="expand" class-name="hidden">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="商品名称">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="所属店铺">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="商品 ID">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="店铺 ID">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="商品分类">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="店铺地址">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="商品描述">
                <span>{{ props.row.name }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      searchPage: 1,
      searchTotalPage: 1,
      search: "",
      songList: [],
      review_status: {
        0: "未提交审核",
        1: "审核中",
        2: "审核通过",
        3: "审核不通过",
      },
      dom: "",
      scrollTimer: "",
    };
  },
  methods: {
    //播放
    play(hash, id) {
      //暂停
      if (
        document.getElementById(id).getAttribute("class").indexOf("pause") > -1
      ) {
        document.getElementById(id).setAttribute("class", "play");
        document.getElementById("audio").pause();
      } else if (
        document.getElementById(id).getAttribute("class").indexOf("play") > -1
      ) {
        //播放
        //暂停再播放，不重新请求
        if (document.getElementById(id).getAttribute("data-url")) {
          //是否切换了歌曲
          if (
            document.getElementById(id).getAttribute("data-url") ==
            document.getElementById("audio").getAttribute("src")
          ) {
            //没切换
            document.getElementById(id).setAttribute("class", "pause");
            document.getElementById("audio").play();
          } else {
            //切换歌曲
            document
              .getElementById("audio")
              .setAttribute(
                "src",
                document.getElementById(id).getAttribute("data-url")
              );
            const list = document.getElementsByClassName("pause");
            for (let i = 0; i < list.length; i++) {
              list[i].setAttribute("class", "play");
            }
            document.getElementById(id).setAttribute("class", "pause");
            //document.getElementById(id).setAttribute("data-url", url);
          }
        } else {
          this.api({
            apiName: "songURL",
            methods: "GET",
            getData: {
              biz: "musician_song_dj",
              field: "song_hash",
              file: hash,
            },
          }).then((res) => {
            console.log(res);
            const url = res.data.url;
            document.getElementById("audio").setAttribute("src", url);
            const list = document.getElementsByClassName("pause");
            for (let i = 0; i < list.length; i++) {
              list[i].setAttribute("class", "play");
            }
            document.getElementById(id).setAttribute("class", "pause");
            document.getElementById(id).setAttribute("data-url", url);
          }).catch(err => {
            window.eventEmitter.emit("toast", "无播放链接");
          })
        }
      }
    },
    //滚动事件
    event() {
      this.dom = this.$refs.songsTable.bodyWrapper;
      this.dom.addEventListener("scroll", () => {
        //最后一页返回
        if (this.searchPage > this.searchTotalPage) return;
        // 滚动距离
        let scrollTop = this.dom.scrollTop;
        // 变量windowHeight是可视区的高度
        let windowHeight = this.dom.clientHeight || this.dom.clientHeight;
        // 变量scrollHeight是滚动条的总高度
        let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight;
        if (scrollTop + windowHeight === scrollHeight) {
          //监听滚动到div底部
          this.scrollTimer && clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            this.getSongList();
          }, 500);
        }
      });
    },
    getSongList(page) {
      this.api({
        apiName: "songList",
        methods: "GET",
        getData: {
          page: page || this.searchPage || 1,
          pagesize: 20,
          biz: "musician_song_dj",
        },
      }).then((res) => {
        const data = res.data;
        this.searchTotalPage = Math.ceil(data.total / 20);
        this.searchPage++;
        this.songList = this.songList.concat(data.list);
      });
    },
    toggleRowExpansion(row) {
      this.$refs.songsTable.toggleRowExpansion(row);
    },
    gotoAdd() {
      this.$router.push(`/editsong`);
    },
    editSong(id) {
      this.$router.push(`/editsong/${id}`);
    },
    /* 审核状态        上架状态               编辑按钮    
    1: "审核中"        待上架，               作品审核中，不能编辑
    2: "审核通过"      上架中/上架失败/已上架   作品上架中，不能编辑/作品上架失败，有疑问请联系客服/作品已上架，不能编辑
    3: "审核不通过"    上架失败，              可以编辑 */
    //获取我的状态
    myStatus(cb) {
      this.api({
        apiName: "myStatus",
        methods: "GET",
        getData: {
          biz: "musician_author_dj",
        },
      }).then((res) => {
        console.log(res);
        const data = res.data;
        //入驻
        if (data.is_settle) {
          cb && typeof cb === "function" && cb();
        } else if(!data.info) {
          this.$router.push("/enter");
        } else if(data.info.exists_author) {
          this.$router.push("/home");
        } else {
          cb && typeof cb === "function" && cb();
        }
      });
    },
    checkStatus(scope){
      return this.review_status[scope.row.review_status]
    },
    sjStatus(scope){
      if(scope.row.review_status == 1){
        return '待上架'
      }else if(scope.row.review_status == 2){
        if(scope.row.audio && scope.row.audio.is_publish == 1){
          return '已上架'
        }else{
          return scope.row.released_at && new Date().getTime() > new Date(scope.row.released_at.replace(/-/g,"/")).getTime() ? '上架失败' : '上架中'
        }
      }else if(scope.row.review_status == 3){
        return '上架失败'
      }
    },
    toolTip(scope){
      if(scope.row.review_status == 1){
        return '作品审核中，不能编辑'
      }else if(scope.row.review_status == 2){
        if(scope.row.audio && scope.row.audio.is_publish == 1){
          return "作品已上架，不能编辑"
        }else{
          return scope.row.released_at && new Date().getTime() > new Date(scope.row.released_at.replace(/-/g,"/")).getTime() ? '作品上架失败，有疑问请联系客服' : '作品上架中，不能编辑'
        }
      }
    }
  },
  mounted() {
    this.event();
    this.$nextTick(() => {
      this.myStatus(this.getSongList);
    });
  },
};
</script>

<style lang="scss">
.work {
  background: #fff;
  height: 100%;
  header {
    width: 100%;
    height: 90px;
    line-height: 90px;
    position: relative;
    .add {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      background-color: #0090ff;
      color: #fff;
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
    .tab {
      height: 60px;
      line-height: 60px;
      font-size: 18px;
      > div {
        width: 130px;
        height: 40px;
        text-align: center;
        position: relative;
      }
      .active {
        color: #0090ff;
        &::after {
          content: "";
          position: absolute;
          width: 40px;
          height: 3px;
          border-radius: 1px;
          background-color: #0090ff;
          bottom: -20px;
          left: 50%;
          margin-left: -20px;
        }
      }
    }
    .search-c {
      width: 260px;
      height: 40px;
      border-radius: 20px;
      background-color: #eff0f5;
      position: absolute;
      right: 20px;
      top: 20px;
      .search {
        font-size: 16px;
        color: #888;
        left: 20px;
      }
    }
  }
  .content {
    height: calc(100vh - 100px);
    overflow-y: scroll;
    .status-img {
      width: 20px;
      height: 20px;
    }
    .play {
      display: inline-block;
      width: 11px;
      height: 13px;
      cursor: pointer;
      background: url("../assets/img/play.png") center center no-repeat;
      background-size: 11px 13px;
    }
    .pause {
      display: inline-block;
      width: 11px;
      height: 13px;
      cursor: pointer;
      background: url("../assets/img/pause.png") center center no-repeat;
      background-size: 11px 13px;
    }
    .notpass-reason {
      color: red;
      display: inline-block;
      border: 1px solid red;
      width: 12px;
      height: 12px;
      line-height: 12px;
      font-size: 12px;
      border-radius: 7px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Work.vue